import { render, staticRenderFns } from "./LicenseAgreement.vue?vue&type=template&id=32088620&scoped=true&"
import script from "./LicenseAgreement.vue?vue&type=script&lang=js&"
export * from "./LicenseAgreement.vue?vue&type=script&lang=js&"
import style0 from "./LicenseAgreement.vue?vue&type=style&index=0&id=32088620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32088620",
  null
  
)

export default component.exports